import { enterPusherChannelAndBindEvents } from 'utils/realTimeEventHelpers';

const individual_socket_events = [
  {
    event_name: 'new_notification',
    action_name: 'addNotification',
  },
  {
    event_name: 'student_nudged',
    action_name: 'SOCKET_ReceiveNudge',
  },
  {
    event_name: 'students_invited_to_discussion',
    action_name: 'addLiveDiscussionToCourseState',
  },
  {
    event_name: 'students_invited_to_roundtable',
    action_name: 'addRoundtableToCourseState',
  },
  {
    event_name: 'change_user_role',
    action_name: 'SOCKET_changeUserRole',
  },
  {
    event_name: 'delete_student_from_school',
    action_name: 'SOCKET_deleteUserFromSchool',
  },
  {
    event_name: 'user_auth',
    action_name: 'pusherAuthentication',
  },
  {
    event_name: 'invite_co_teacher', 
    action_name: 'receiveCoTeacherInvite'
  }
];

export default {
  data() {
    return {};
  },
  methods: {
    setup_individual_socket_events(user_id) {
      enterPusherChannelAndBindEvents.call(
        this,
        user_id,
        individual_socket_events
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/sockets/individualSocketEvents.js